import React, { useState, useEffect } from "react";
import { Box, Button, Grid, makeStyles, Typography } from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import editorConfiguration from "../../../../util/EditorConfiguration";
import { useLoading } from "../../../../util/LoadingProvider";

const defaultFormValues = {
  localizations: {
    en: {
      content: "",
    },
    tc: {
      content: "",
    },
  },
};

const useStyles = makeStyles((theme) => ({
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "362px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: 0,
  },
}));

export default function MovieNotePage({ disabled, ...props }) {
  const [defaultValues] = useState(defaultFormValues);
  const [initialValues, setInitialValues] = useState({});
  const { setLoading } = useLoading();

  const classes = useStyles();

  const {
    control,
    handleSubmit,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const onSubmit = (value) => {
    updateMovieNote(value);
  };

  const getMovieNote = async () => {
    setLoading(true);
    try {
      const result = await apiHelper.cinefan.getMovieNote();
      console.log(result);
      setInitialValues(result.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const updateMovieNote = async (value) => {
    try {
      const result = await apiHelper.cinefan.updateMovieNote(value);
      console.log(result);
      if (result.data.code === 0) {
        await getMovieNote();
        toast.dark("Your changes is saved.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getMovieNote();
  }, []);

  return (
    <div className={classes.content}>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          Movies &gt; Movie Note
        </Typography>
      </Box>
      {initialValues.localizations ? (
        <form onSubmit={handleSubmit(onSubmit)}>
          <Box fontWeight={900} fontSize={13} mb={2} width="100%">
            <Typography variant="p">Edit Movie Note (English)</Typography>
          </Box>

          <Grid item xs={12}>
            <Controller
              name="localizations.en.content"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <CKEditor
                  editor={Editor}
                  config={editorConfiguration}
                  data={field.value}
                  disabled={disabled}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                    editor.setData(initialValues.localizations.en);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    field.onChange(data);
                    // console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }}
                />
              )}
            />
          </Grid>

          <Box fontWeight={900} fontSize={13} mt={4} mb={2} width="100%">
            <Typography variant="p">
              Edit Movie Note (Traditional Chinese)
            </Typography>
          </Box>

          <Grid item xs={12}>
            <Controller
              name="localizations.tc.content"
              control={control}
              render={({ field, fieldState: { error } }) => (
                <CKEditor
                  editor={Editor}
                  config={editorConfiguration}
                  data={field.value}
                  disabled={disabled}
                  onReady={(editor) => {
                    // You can store the "editor" and use when it is needed.
                    console.log("Editor is ready to use!", editor);
                    editor.setData(initialValues.localizations.tc);
                  }}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    field.onChange(data);
                    // console.log({ event, editor, data });
                  }}
                  onBlur={(event, editor) => {
                    console.log("Blur.", editor);
                  }}
                  onFocus={(event, editor) => {
                    console.log("Focus.", editor);
                  }}
                />
              )}
            />
          </Grid>

          {disabled || (
            <div className={classes.buttonGroup}>
              <Button
                type="submit"
                variant="contained"
                disableElevation
                style={{
                  color: "white",
                  background: "#306F9D",
                  marginRight: "5px",
                  padding: "9px 16px",
                }}
              >
                Save
              </Button>
            </div>
          )}
        </form>
      ) : (
        <></>
      )}
    </div>
  );
}
